import svgPaths from "./svg-vfnibauwdx";

function Heading() {
  return (
    <div className="h-[54.013px] relative shrink-0 w-[1199.997px]" data-name="Heading 1">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[54px] left-0 not-italic text-[#1a1f36] text-[36px] top-[-0.38px] tracking-[-0.9px] whitespace-nowrap">Manage Team</p>
      </div>
    </div>
  );
}

function Paragraph() {
  return (
    <div className="h-[23.994px] relative shrink-0 w-[1199.997px]" data-name="Paragraph">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[24px] left-0 not-italic text-[#6e7891] text-[16px] top-[-0.69px] whitespace-nowrap">View and update your team details for this hackathon.</p>
      </div>
    </div>
  );
}

function Header() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[85.999px] items-start left-[106.6px] top-[47.99px] w-[1199.997px]" data-name="Header">
      <Heading />
      <Paragraph />
    </div>
  );
}

function Label() {
  return (
    <div className="h-[16.507px] relative shrink-0 w-[562.844px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[#0058ab] text-[11px] top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Team Name</p>
      </div>
    </div>
  );
}

function Paragraph1() {
  return (
    <div className="h-[27.007px] relative shrink-0 w-[562.844px]" data-name="Paragraph">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[27px] left-0 not-italic text-[#1a1f36] text-[18px] top-[0.31px] whitespace-nowrap">Innovation Squad</p>
      </div>
    </div>
  );
}

function Container1() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[51.506px] items-start left-0 top-0 w-[562.844px]" data-name="Container">
      <Label />
      <Paragraph1 />
    </div>
  );
}

function Label1() {
  return (
    <div className="h-[16.507px] relative shrink-0 w-[562.862px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[#0058ab] text-[11px] top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Hackathon</p>
      </div>
    </div>
  );
}

function Paragraph2() {
  return (
    <div className="h-[27.007px] relative shrink-0 w-[562.862px]" data-name="Paragraph">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[27px] left-0 not-italic text-[#0058ab] text-[18px] top-[0.31px] whitespace-nowrap">Global AI Hackathon 2026</p>
      </div>
    </div>
  );
}

function Container2() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[51.506px] items-start left-[586.84px] top-0 w-[562.862px]" data-name="Container">
      <Label1 />
      <Paragraph2 />
    </div>
  );
}

function Container() {
  return (
    <div className="h-[51.506px] relative shrink-0 w-full" data-name="Container">
      <Container1 />
      <Container2 />
    </div>
  );
}

function Container3() {
  return <div className="bg-[#e4e8ee] h-[0.992px] shrink-0 w-full" data-name="Container" />;
}

function Icon() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Label2() {
  return (
    <div className="h-[16.507px] relative shrink-0 w-[177.175px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[#0058ab] text-[11px] top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Team Leader (Read-Only)</p>
      </div>
    </div>
  );
}

function Container5() {
  return (
    <div className="h-[16.507px] relative shrink-0 w-[1149.7px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex gap-[7.992px] items-center relative size-full">
        <Icon />
        <Label2 />
      </div>
    </div>
  );
}

function Icon1() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[99.601px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-0 not-italic text-[#1a1f36] text-[14px] top-[-0.85px] whitespace-nowrap">Sarah Johnson</p>
      </div>
    </div>
  );
}

function Container7() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[127.582px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex gap-[11.997px] items-center relative size-full">
        <Icon1 />
        <Text />
      </div>
    </div>
  );
}

function Icon2() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_305)" id="Icon">
          <path d={svgPaths.p2d302620} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p1ba99900} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_305">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text1() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[205.607px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[21px] left-0 not-italic text-[#0058ab] text-[14px] top-[-0.85px] whitespace-nowrap">sarah.johnson@capgemini.com</p>
      </div>
    </div>
  );
}

function Container8() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[233.588px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex gap-[11.997px] items-center relative size-full">
        <Icon2 />
        <Text1 />
      </div>
    </div>
  );
}

function Container6() {
  return (
    <div className="bg-[#f5f7fb] h-[52.967px] relative rounded-[12px] shrink-0 w-[1149.7px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-between px-[15.984px] relative size-full">
        <Container7 />
        <Container8 />
      </div>
    </div>
  );
}

function Container4() {
  return (
    <div className="content-stretch flex flex-col gap-[11.997px] h-[81.471px] items-start relative shrink-0 w-full" data-name="Container">
      <Container5 />
      <Container6 />
    </div>
  );
}

function InfoCard() {
  return (
    <div className="absolute bg-white content-stretch flex flex-col gap-[19.989px] h-[224.243px] items-start left-[106.6px] pb-[1.155px] pt-[25.148px] px-[25.148px] rounded-[16px] top-[165.97px] w-[1199.997px]" data-name="InfoCard">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[16px] shadow-[0px_1px_3px_0px_rgba(26,31,54,0.04),0px_1px_2px_0px_rgba(26,31,54,0.03)]" />
      <Container />
      <Container3 />
      <Container4 />
    </div>
  );
}

function Icon3() {
  return (
    <div className="h-[19.989px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute inset-[8.33%]" data-name="Vector">
        <div className="absolute inset-[-5%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18.3231 18.3231">
            <path d={svgPaths.p3a2fc500} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
          </svg>
        </div>
      </div>
      <div className="absolute bottom-[33.33%] left-1/2 right-1/2 top-1/2" data-name="Vector">
        <div className="absolute inset-[-25%_-0.83px]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1.66574 4.99718">
            <path d="M0.83287 4.16431V0.83287" id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
          </svg>
        </div>
      </div>
      <div className="absolute bottom-[66.67%] left-1/2 right-[49.96%] top-[33.33%]" data-name="Vector">
        <div className="absolute inset-[-0.83px]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1.67404 1.66574">
            <path d="M0.83287 0.83287H0.841169" id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Container10() {
  return (
    <div className="relative shrink-0 size-[19.989px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start relative size-full">
        <Icon3 />
      </div>
    </div>
  );
}

function Heading1() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-full" data-name="Heading 3">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-0 not-italic text-[#1a1f36] text-[14px] top-[-0.85px] whitespace-nowrap">Team Size Rules</p>
    </div>
  );
}

function Icon4() {
  return (
    <div className="absolute left-0 size-[15.984px] top-[3.99px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p2d5f5280} id="Vector" stroke="var(--stroke-0, #00D5D0)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.99798" />
        </g>
      </svg>
    </div>
  );
}

function Text2() {
  return (
    <div className="absolute h-[19.502px] left-[23.98px] top-0 w-[187.242px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">Minimum team size: 1 member</p>
    </div>
  );
}

function Container13() {
  return (
    <div className="h-[19.971px] relative shrink-0 w-[1125.725px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Icon4 />
        <Text2 />
      </div>
    </div>
  );
}

function Icon5() {
  return (
    <div className="absolute left-0 size-[15.984px] top-[3.99px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p2d5f5280} id="Vector" stroke="var(--stroke-0, #00D5D0)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.99798" />
        </g>
      </svg>
    </div>
  );
}

function Text3() {
  return (
    <div className="absolute h-[19.502px] left-[23.98px] top-0 w-[207.123px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">Maximum team size: 10 members</p>
    </div>
  );
}

function Container14() {
  return (
    <div className="h-[19.971px] relative shrink-0 w-[1125.725px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Icon5 />
        <Text3 />
      </div>
    </div>
  );
}

function Icon6() {
  return (
    <div className="absolute left-0 size-[15.984px] top-[3.99px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p2d5f5280} id="Vector" stroke="var(--stroke-0, #00D5D0)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.99798" />
        </g>
      </svg>
    </div>
  );
}

function Text4() {
  return (
    <div className="absolute h-[19.502px] left-[23.98px] top-0 w-[210.189px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">All member emails must be unique</p>
    </div>
  );
}

function Container15() {
  return (
    <div className="h-[19.971px] relative shrink-0 w-[1125.725px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Icon6 />
        <Text4 />
      </div>
    </div>
  );
}

function Container12() {
  return (
    <div className="content-stretch flex flex-col gap-[7.992px] h-[75.896px] items-start relative shrink-0 w-full" data-name="Container">
      <Container13 />
      <Container14 />
      <Container15 />
    </div>
  );
}

function Container11() {
  return (
    <div className="flex-[1125.725_0_0] h-[108.892px] min-h-px min-w-px relative" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col gap-[11.997px] items-start relative size-full">
        <Heading1 />
        <Container12 />
      </div>
    </div>
  );
}

function Container9() {
  return (
    <div className="content-stretch flex gap-[11.997px] h-[108.892px] items-start relative shrink-0 w-full" data-name="Container">
      <Container10 />
      <Container11 />
    </div>
  );
}

function TeamSizeRules() {
  return (
    <div className="absolute bg-[#ebf8fd] content-stretch flex flex-col h-[151.179px] items-start left-[106.6px] pb-[1.155px] pt-[21.143px] px-[21.143px] rounded-[12px] top-[422.2px] w-[1199.997px]" data-name="TeamSizeRules">
      <div aria-hidden="true" className="absolute border-[1.155px] border-[rgba(29,184,242,0.2)] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <Container9 />
    </div>
  );
}

function Icon7() {
  return (
    <div className="relative shrink-0 size-[19.989px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 19.9888 19.9888">
        <g clipPath="url(#clip0_54_284)" id="Icon">
          <path d={svgPaths.p38453800} id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
          <path d={svgPaths.p2383980} id="Vector_2" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
          <path d={svgPaths.p209beee0} id="Vector_3" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
          <path d={svgPaths.p243f0280} id="Vector_4" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66574" />
        </g>
        <defs>
          <clipPath id="clip0_54_284">
            <rect fill="white" height="19.9888" width="19.9888" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Label3() {
  return (
    <div className="h-[16.507px] opacity-90 relative shrink-0 w-[131.912px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Current Team Size</p>
      </div>
    </div>
  );
}

function Container16() {
  return (
    <div className="content-stretch flex gap-[11.997px] h-[19.989px] items-center relative shrink-0 w-full" data-name="Container">
      <Icon7 />
      <Label3 />
    </div>
  );
}

function Text5() {
  return (
    <div className="absolute h-[48.006px] left-0 top-0 w-[30.831px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[48px] left-0 not-italic text-[48px] text-white top-[-0.77px] whitespace-nowrap">4</p>
    </div>
  );
}

function Text6() {
  return (
    <div className="absolute h-[27.007px] left-[38.82px] opacity-90 top-[13.01px] w-[115.639px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[27px] left-0 not-italic text-[18px] text-white top-[0.31px] whitespace-nowrap">/ 10 members</p>
    </div>
  );
}

function Container17() {
  return (
    <div className="h-[48.006px] relative shrink-0 w-full" data-name="Container">
      <Text5 />
      <Text6 />
    </div>
  );
}

function CurrentTeamSize() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[11.997px] h-[127.979px] items-start left-[106.6px] pt-[23.994px] px-[23.994px] rounded-[16px] shadow-[0px_4px_12px_0px_rgba(0,88,171,0.2)] top-[605.37px] w-[1199.997px]" data-name="CurrentTeamSize" style={{ backgroundImage: "linear-gradient(90deg, rgb(0, 88, 171) 0%, rgb(0, 95, 176) 7.1429%, rgb(0, 101, 181) 14.286%, rgb(0, 108, 186) 21.429%, rgb(1, 115, 191) 28.571%, rgb(2, 122, 196) 35.714%, rgb(4, 129, 201) 42.857%, rgb(6, 135, 206) 50%, rgb(9, 142, 211) 57.143%, rgb(13, 149, 217) 64.286%, rgb(16, 156, 222) 71.429%, rgb(19, 163, 227) 78.571%, rgb(22, 170, 232) 85.714%, rgb(26, 177, 237) 92.857%, rgb(29, 184, 242) 100%)" }}>
      <Container16 />
      <Container17 />
    </div>
  );
}

function Icon8() {
  return (
    <div className="absolute left-[23.99px] size-[15.984px] top-[14.5px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d="M7.99192 3.32997V12.6539" id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66499" />
          <path d="M3.32997 7.99192H12.6539" id="Vector_2" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66499" />
        </g>
      </svg>
    </div>
  );
}

function Button() {
  return (
    <div className="absolute bg-[#00828e] h-[44.993px] left-[106.6px] rounded-[12px] top-[765.33px] w-[198.607px]" data-name="Button">
      <Icon8 />
      <p className="-translate-x-1/2 absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-[111.47px] not-italic text-[14px] text-center text-white top-[11.15px] whitespace-nowrap">Add Team Member</p>
    </div>
  );
}

function Heading2() {
  return (
    <div className="h-[27.007px] relative shrink-0 w-full" data-name="Heading 3">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[27px] left-0 not-italic text-[#1a1f36] text-[18px] top-[0.31px] whitespace-nowrap">Add New Member</p>
    </div>
  );
}

function Label4() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[566.272px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">Member Name</p>
      </div>
    </div>
  );
}

function TextInput() {
  return (
    <div className="h-[47.302px] relative rounded-[12px] shrink-0 w-[566.272px]" data-name="Text Input">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center overflow-clip px-[16px] py-[12px] relative rounded-[inherit] size-full">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[normal] not-italic relative shrink-0 text-[#8b93a8] text-[14px] whitespace-nowrap">Enter full name</p>
      </div>
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
    </div>
  );
}

function Container20() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[74.796px] items-start left-0 top-0 w-[566.272px]" data-name="Container">
      <Label4 />
      <TextInput />
    </div>
  );
}

function Label5() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[566.29px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">Member Email</p>
      </div>
    </div>
  );
}

function EmailInput() {
  return (
    <div className="h-[47.302px] relative rounded-[12px] shrink-0 w-[566.29px]" data-name="Email Input">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center overflow-clip px-[16px] py-[12px] relative rounded-[inherit] size-full">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[normal] not-italic relative shrink-0 text-[#8b93a8] text-[14px] whitespace-nowrap">Enter email address</p>
      </div>
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
    </div>
  );
}

function Container21() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[74.796px] items-start left-[582.26px] top-0 w-[566.29px]" data-name="Container">
      <Label5 />
      <EmailInput />
    </div>
  );
}

function Label6() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[566.272px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">Grade</p>
      </div>
    </div>
  );
}

function TextInput1() {
  return (
    <div className="h-[47.302px] relative rounded-[12px] shrink-0 w-[566.272px]" data-name="Text Input">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center overflow-clip px-[16px] py-[12px] relative rounded-[inherit] size-full">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[normal] not-italic relative shrink-0 text-[#8b93a8] text-[14px] whitespace-nowrap">e.g., A1, B2</p>
      </div>
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
    </div>
  );
}

function Container22() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[74.796px] items-start left-0 top-[90.78px] w-[566.272px]" data-name="Container">
      <Label6 />
      <TextInput1 />
    </div>
  );
}

function Label7() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[566.29px]" data-name="Label">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[19.5px] left-0 not-italic text-[#1a1f36] text-[13px] top-[0.15px] whitespace-nowrap">Job Role</p>
      </div>
    </div>
  );
}

function TextInput2() {
  return (
    <div className="h-[47.302px] relative rounded-[12px] shrink-0 w-[566.29px]" data-name="Text Input">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center overflow-clip px-[16px] py-[12px] relative rounded-[inherit] size-full">
        <p className="font-['Inter:Regular',sans-serif] font-normal leading-[normal] not-italic relative shrink-0 text-[#8b93a8] text-[14px] whitespace-nowrap">e.g., Developer, Designer</p>
      </div>
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
    </div>
  );
}

function Container23() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[7.992px] h-[74.796px] items-start left-[582.26px] top-[90.78px] w-[566.29px]" data-name="Container">
      <Label7 />
      <TextInput2 />
    </div>
  );
}

function Container19() {
  return (
    <div className="h-[165.575px] relative shrink-0 w-full" data-name="Container">
      <Container20 />
      <Container21 />
      <Container22 />
      <Container23 />
    </div>
  );
}

function Button1() {
  return (
    <div className="bg-[#0058ab] h-[47.302px] relative rounded-[12px] shrink-0 w-[134.383px]" data-name="Button">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="-translate-x-1/2 absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-[67.49px] not-italic text-[14px] text-center text-white top-[12.31px] whitespace-nowrap">Add Member</p>
      </div>
    </div>
  );
}

function Button2() {
  return (
    <div className="bg-white h-[47.302px] relative rounded-[12px] shrink-0 w-[96.571px]" data-name="Button">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="-translate-x-1/2 absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-[48.65px] not-italic text-[#6e7891] text-[14px] text-center top-[12.31px] whitespace-nowrap">Cancel</p>
      </div>
    </div>
  );
}

function Container24() {
  return (
    <div className="content-stretch flex gap-[11.997px] h-[47.302px] items-start relative shrink-0 w-full" data-name="Container">
      <Button1 />
      <Button2 />
    </div>
  );
}

function Container18() {
  return (
    <div className="absolute bg-white content-stretch flex flex-col gap-[19.989px] h-[327.849px] items-start left-[106.6px] pl-[27.458px] pr-[23.994px] pt-[23.994px] rounded-[16px] top-[842.31px] w-[1199.997px]" data-name="Container">
      <div aria-hidden="true" className="absolute border-[#feb100] border-l-[3.464px] border-solid inset-0 pointer-events-none rounded-[16px] shadow-[0px_1px_3px_0px_rgba(26,31,54,0.04),0px_1px_2px_0px_rgba(26,31,54,0.03)]" />
      <Heading2 />
      <Container19 />
      <Container24 />
    </div>
  );
}

function Text7() {
  return (
    <div className="absolute h-[16.507px] left-0 top-0 w-[273.547px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Member Name</p>
    </div>
  );
}

function Text8() {
  return (
    <div className="absolute h-[16.507px] left-[289.53px] top-0 w-[273.547px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Email</p>
    </div>
  );
}

function Text9() {
  return (
    <div className="absolute h-[16.507px] left-[579.06px] top-0 w-[136.783px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Grade</p>
    </div>
  );
}

function Text10() {
  return (
    <div className="absolute h-[16.507px] left-[731.83px] top-0 w-[205.156px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Job Role</p>
    </div>
  );
}

function Text11() {
  return (
    <div className="absolute h-[16.507px] left-[952.97px] top-0 w-[136.783px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Status</p>
    </div>
  );
}

function Text12() {
  return (
    <div className="absolute h-[16.507px] left-[1105.74px] top-0 w-[59.985px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[16.5px] left-0 not-italic text-[11px] text-white top-[0.15px] tracking-[1.1px] uppercase whitespace-nowrap">Action</p>
    </div>
  );
}

function Container27() {
  return (
    <div className="h-[16.507px] relative shrink-0 w-full" data-name="Container">
      <Text7 />
      <Text8 />
      <Text9 />
      <Text10 />
      <Text11 />
      <Text12 />
    </div>
  );
}

function Container26() {
  return (
    <div className="h-[48.475px] relative shrink-0 w-full" data-name="Container" style={{ backgroundImage: "linear-gradient(90deg, rgb(0, 88, 171) 0%, rgb(0, 95, 176) 7.1429%, rgb(0, 101, 181) 14.286%, rgb(0, 108, 186) 21.429%, rgb(1, 115, 191) 28.571%, rgb(2, 122, 196) 35.714%, rgb(4, 129, 201) 42.857%, rgb(6, 135, 206) 50%, rgb(9, 142, 211) 57.143%, rgb(13, 149, 217) 64.286%, rgb(16, 156, 222) 71.429%, rgb(19, 163, 227) 78.571%, rgb(22, 170, 232) 85.714%, rgb(26, 177, 237) 92.857%, rgb(29, 184, 242) 100%)" }}>
      <div className="content-stretch flex flex-col items-start pt-[15.984px] px-[15.984px] relative size-full">
        <Container27 />
      </div>
    </div>
  );
}

function Icon9() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text13() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[91.086px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-0 not-italic text-[#1a1f36] text-[14px] top-[-0.85px] whitespace-nowrap">Michael Chen</p>
      </div>
    </div>
  );
}

function Container29() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[20.999px] items-center left-[17.14px] top-[22.62px] w-[349.786px]" data-name="Container">
      <Icon9 />
      <Text13 />
    </div>
  );
}

function Icon10() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_305)" id="Icon">
          <path d={svgPaths.p2d302620} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p1ba99900} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_305">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text14() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[186.015px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#0058ab] text-[13px] top-[0.15px] whitespace-nowrap">michael.chen@capgemini.com</p>
      </div>
    </div>
  );
}

function Container30() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[382.91px] top-[23.36px] w-[349.786px]" data-name="Container">
      <Icon10 />
      <Text14 />
    </div>
  );
}

function Icon11() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_276)" id="Icon">
          <path d={svgPaths.p3379daf0} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p10c44b00} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_276">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text15() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[14.486px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">B1</p>
      </div>
    </div>
  );
}

function Container31() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[748.68px] top-[23.36px] w-[79.991px]" data-name="Container">
      <Icon11 />
      <Text15 />
    </div>
  );
}

function Icon12() {
  return (
    <div className="h-[15.984px] relative shrink-0 w-[14.486px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 14.4865 15.9838">
        <g id="Icon">
          <path d={svgPaths.p25871a80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2072" />
          <path d={svgPaths.p23d18f00} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2072" />
        </g>
      </svg>
    </div>
  );
}

function Text16() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[113.511px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">Full Stack Developer</p>
      </div>
    </div>
  );
}

function Container32() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[844.65px] top-[23.36px] w-[139.994px]" data-name="Container">
      <Icon12 />
      <Text16 />
    </div>
  );
}

function Text17() {
  return (
    <div className="absolute h-[17.986px] left-[12px] top-[3.99px] w-[36.171px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[18px] left-0 not-italic text-[12px] text-white top-[0.15px] whitespace-nowrap">Active</p>
    </div>
  );
}

function Container33() {
  return (
    <div className="absolute bg-[#00d5d0] h-[25.96px] left-[1000.63px] rounded-[8px] top-[21.04px] w-[60.165px]" data-name="Container">
      <Text17 />
    </div>
  );
}

function Icon13() {
  return (
    <div className="h-[15.984px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute bottom-3/4 left-[12.5%] right-[12.5%] top-1/4" data-name="Vector">
        <div className="absolute inset-[-0.67px_-5.56%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 13.3199 1.33198">
            <path d={svgPaths.p6b6b500} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
      <div className="absolute inset-[8.33%_20.83%]" data-name="Vector">
        <div className="absolute inset-[-5%_-7.14%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 10.6559 14.6519">
            <path d={svgPaths.p203678a0} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Button3() {
  return (
    <div className="absolute content-stretch flex flex-col items-start left-[1116.61px] pt-[7.992px] px-[7.992px] rounded-[8px] size-[31.968px] top-[17.14px]" data-name="Button">
      <Icon13 />
    </div>
  );
}

function MemberRow() {
  return (
    <div className="bg-white h-[66.245px] relative rounded-[12px] shrink-0 w-[1165.72px]" data-name="MemberRow">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Container29 />
        <Container30 />
        <Container31 />
        <Container32 />
        <Container33 />
        <Button3 />
      </div>
    </div>
  );
}

function Icon14() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text18() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[77.303px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-0 not-italic text-[#1a1f36] text-[14px] top-[-0.85px] whitespace-nowrap">Emily Wang</p>
      </div>
    </div>
  );
}

function Container34() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[20.999px] items-center left-[17.14px] top-[22.62px] w-[349.786px]" data-name="Container">
      <Icon14 />
      <Text18 />
    </div>
  );
}

function Icon15() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_305)" id="Icon">
          <path d={svgPaths.p2d302620} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p1ba99900} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_305">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text19() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[173.856px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#0058ab] text-[13px] top-[0.15px] whitespace-nowrap">emily.wang@capgemini.com</p>
      </div>
    </div>
  );
}

function Container35() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[382.91px] top-[23.36px] w-[349.786px]" data-name="Container">
      <Icon15 />
      <Text19 />
    </div>
  );
}

function Icon16() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_276)" id="Icon">
          <path d={svgPaths.p3379daf0} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p10c44b00} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_276">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text20() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[16.327px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">B2</p>
      </div>
    </div>
  );
}

function Container36() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[748.68px] top-[23.36px] w-[79.991px]" data-name="Container">
      <Icon16 />
      <Text20 />
    </div>
  );
}

function Icon17() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text21() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[94.009px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">UI/UX Designer</p>
      </div>
    </div>
  );
}

function Container37() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[844.65px] top-[23.36px] w-[139.994px]" data-name="Container">
      <Icon17 />
      <Text21 />
    </div>
  );
}

function Text22() {
  return (
    <div className="absolute h-[17.986px] left-[12px] top-[3.99px] w-[46.869px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[18px] left-0 not-italic text-[12px] text-white top-[0.15px] whitespace-nowrap">Pending</p>
    </div>
  );
}

function Container38() {
  return (
    <div className="absolute bg-[#feb100] h-[25.96px] left-[1000.63px] rounded-[8px] top-[21.04px] w-[70.863px]" data-name="Container">
      <Text22 />
    </div>
  );
}

function Icon18() {
  return (
    <div className="h-[15.984px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute bottom-3/4 left-[12.5%] right-[12.5%] top-1/4" data-name="Vector">
        <div className="absolute inset-[-0.67px_-5.56%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 13.3199 1.33198">
            <path d={svgPaths.p6b6b500} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
      <div className="absolute inset-[8.33%_20.83%]" data-name="Vector">
        <div className="absolute inset-[-5%_-7.14%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 10.6559 14.6519">
            <path d={svgPaths.p203678a0} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Button4() {
  return (
    <div className="absolute content-stretch flex flex-col items-start left-[1116.61px] pt-[7.992px] px-[7.992px] rounded-[8px] size-[31.968px] top-[17.14px]" data-name="Button">
      <Icon18 />
    </div>
  );
}

function MemberRow1() {
  return (
    <div className="bg-white h-[66.245px] relative rounded-[12px] shrink-0 w-[1165.72px]" data-name="MemberRow">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Container34 />
        <Container35 />
        <Container36 />
        <Container37 />
        <Container38 />
        <Button4 />
      </div>
    </div>
  );
}

function Icon19() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text23() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[110.011px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-0 not-italic text-[#1a1f36] text-[14px] top-[-0.85px] whitespace-nowrap">James Okonkwo</p>
      </div>
    </div>
  );
}

function Container39() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[20.999px] items-center left-[17.14px] top-[22.62px] w-[349.786px]" data-name="Container">
      <Icon19 />
      <Text23 />
    </div>
  );
}

function Icon20() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_305)" id="Icon">
          <path d={svgPaths.p2d302620} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p1ba99900} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_305">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text24() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[199.69px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#0058ab] text-[13px] top-[0.15px] whitespace-nowrap">james.okonkwo@capgemini.com</p>
      </div>
    </div>
  );
}

function Container40() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[382.91px] top-[23.36px] w-[349.786px]" data-name="Container">
      <Icon20 />
      <Text24 />
    </div>
  );
}

function Icon21() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_276)" id="Icon">
          <path d={svgPaths.p3379daf0} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p10c44b00} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_276">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text25() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[16.651px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">A2</p>
      </div>
    </div>
  );
}

function Container41() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[748.68px] top-[23.36px] w-[79.991px]" data-name="Container">
      <Icon21 />
      <Text25 />
    </div>
  );
}

function Icon22() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text26() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[85.476px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">Data Scientist</p>
      </div>
    </div>
  );
}

function Container42() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[844.65px] top-[23.36px] w-[139.994px]" data-name="Container">
      <Icon22 />
      <Text26 />
    </div>
  );
}

function Text27() {
  return (
    <div className="absolute h-[17.986px] left-[12px] top-[3.99px] w-[36.171px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[18px] left-0 not-italic text-[12px] text-white top-[0.15px] whitespace-nowrap">Active</p>
    </div>
  );
}

function Container43() {
  return (
    <div className="absolute bg-[#00d5d0] h-[25.96px] left-[1000.63px] rounded-[8px] top-[21.04px] w-[60.165px]" data-name="Container">
      <Text27 />
    </div>
  );
}

function Icon23() {
  return (
    <div className="h-[15.984px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute bottom-3/4 left-[12.5%] right-[12.5%] top-1/4" data-name="Vector">
        <div className="absolute inset-[-0.67px_-5.56%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 13.3199 1.33198">
            <path d={svgPaths.p6b6b500} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
      <div className="absolute inset-[8.33%_20.83%]" data-name="Vector">
        <div className="absolute inset-[-5%_-7.14%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 10.6559 14.6519">
            <path d={svgPaths.p203678a0} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Button5() {
  return (
    <div className="absolute content-stretch flex flex-col items-start left-[1116.61px] pt-[7.992px] px-[7.992px] rounded-[8px] size-[31.968px] top-[17.14px]" data-name="Button">
      <Icon23 />
    </div>
  );
}

function MemberRow2() {
  return (
    <div className="bg-white h-[66.245px] relative rounded-[12px] shrink-0 w-[1165.72px]" data-name="MemberRow">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Container39 />
        <Container40 />
        <Container41 />
        <Container42 />
        <Container43 />
        <Button5 />
      </div>
    </div>
  );
}

function Icon24() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g id="Icon">
          <path d={svgPaths.p29b56f80} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p54ce940} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
      </svg>
    </div>
  );
}

function Text28() {
  return (
    <div className="h-[20.999px] relative shrink-0 w-[95.344px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[21px] left-0 not-italic text-[#1a1f36] text-[14px] top-[-0.85px] whitespace-nowrap">Lisa Anderson</p>
      </div>
    </div>
  );
}

function Container44() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[20.999px] items-center left-[17.14px] top-[22.62px] w-[349.786px]" data-name="Container">
      <Icon24 />
      <Text28 />
    </div>
  );
}

function Icon25() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_305)" id="Icon">
          <path d={svgPaths.p2d302620} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p1ba99900} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_305">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text29() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[186.448px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#0058ab] text-[13px] top-[0.15px] whitespace-nowrap">lisa.anderson@capgemini.com</p>
      </div>
    </div>
  );
}

function Container45() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[382.91px] top-[23.36px] w-[349.786px]" data-name="Container">
      <Icon25 />
      <Text29 />
    </div>
  );
}

function Icon26() {
  return (
    <div className="relative shrink-0 size-[15.984px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.9838 15.9838">
        <g clipPath="url(#clip0_54_276)" id="Icon">
          <path d={svgPaths.p3379daf0} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          <path d={svgPaths.p10c44b00} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
        </g>
        <defs>
          <clipPath id="clip0_54_276">
            <rect fill="white" height="15.9838" width="15.9838" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Text30() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[14.486px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">B1</p>
      </div>
    </div>
  );
}

function Container46() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[748.68px] top-[23.36px] w-[79.991px]" data-name="Container">
      <Icon26 />
      <Text30 />
    </div>
  );
}

function Icon27() {
  return (
    <div className="h-[15.984px] relative shrink-0 w-[15.154px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.154 15.9838">
        <g id="Icon">
          <path d={svgPaths.p146ad080} id="Vector" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.26283" />
          <path d={svgPaths.p17689bf0} id="Vector_2" stroke="var(--stroke-0, #0058AB)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.26283" />
        </g>
      </svg>
    </div>
  );
}

function Text31() {
  return (
    <div className="h-[19.502px] relative shrink-0 w-[112.843px]" data-name="Text">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[19.5px] left-0 not-italic text-[#6e7891] text-[13px] top-[0.15px] whitespace-nowrap">Backend Developer</p>
      </div>
    </div>
  );
}

function Container47() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[19.502px] items-center left-[844.65px] top-[23.36px] w-[139.994px]" data-name="Container">
      <Icon27 />
      <Text31 />
    </div>
  );
}

function Text32() {
  return (
    <div className="absolute h-[17.986px] left-[12px] top-[3.99px] w-[36.171px]" data-name="Text">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[18px] left-0 not-italic text-[12px] text-white top-[0.15px] whitespace-nowrap">Active</p>
    </div>
  );
}

function Container48() {
  return (
    <div className="absolute bg-[#00d5d0] h-[25.96px] left-[1000.63px] rounded-[8px] top-[21.04px] w-[60.165px]" data-name="Container">
      <Text32 />
    </div>
  );
}

function Icon28() {
  return (
    <div className="h-[15.984px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute bottom-3/4 left-[12.5%] right-[12.5%] top-1/4" data-name="Vector">
        <div className="absolute inset-[-0.67px_-5.56%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 13.3199 1.33198">
            <path d={svgPaths.p6b6b500} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
      <div className="absolute inset-[8.33%_20.83%]" data-name="Vector">
        <div className="absolute inset-[-5%_-7.14%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 10.6559 14.6519">
            <path d={svgPaths.p203678a0} id="Vector" stroke="var(--stroke-0, #FF4D4F)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33198" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Button6() {
  return (
    <div className="absolute content-stretch flex flex-col items-start left-[1116.61px] pt-[7.992px] px-[7.992px] rounded-[8px] size-[31.968px] top-[17.14px]" data-name="Button">
      <Icon28 />
    </div>
  );
}

function MemberRow3() {
  return (
    <div className="bg-white h-[66.245px] relative rounded-[12px] shrink-0 w-[1165.72px]" data-name="MemberRow">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <Container44 />
        <Container45 />
        <Container46 />
        <Container47 />
        <Container48 />
        <Button6 />
      </div>
    </div>
  );
}

function Container28() {
  return (
    <div className="h-[332.937px] relative shrink-0 w-full" data-name="Container">
      <div className="content-stretch flex flex-col gap-[11.997px] items-start pl-[15.984px] pt-[15.984px] relative size-full">
        <MemberRow />
        <MemberRow1 />
        <MemberRow2 />
        <MemberRow3 />
      </div>
    </div>
  );
}

function Container25() {
  return (
    <div className="absolute bg-white h-[383.721px] left-[106.6px] rounded-[16px] top-[1202.14px] w-[1199.997px]" data-name="Container">
      <div className="content-stretch flex flex-col items-start overflow-clip pl-[1.155px] pr-[1.154px] py-[1.155px] relative rounded-[inherit] size-full">
        <Container26 />
        <Container28 />
      </div>
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[16px] shadow-[0px_1px_3px_0px_rgba(26,31,54,0.04),0px_1px_2px_0px_rgba(26,31,54,0.03)]" />
    </div>
  );
}

function Button7() {
  return (
    <div className="bg-[#00828e] h-[54.302px] relative rounded-[12px] shrink-0 w-[173.297px]" data-name="Button">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="-translate-x-1/2 absolute font-['Inter:Medium',sans-serif] font-medium leading-[24px] left-[86.99px] not-italic text-[16px] text-center text-white top-[14.46px] whitespace-nowrap">Save Changes</p>
      </div>
    </div>
  );
}

function Button8() {
  return (
    <div className="bg-white h-[54.302px] relative rounded-[12px] shrink-0 w-[119.157px]" data-name="Button">
      <div aria-hidden="true" className="absolute border-[#e4e8ee] border-[1.155px] border-solid inset-0 pointer-events-none rounded-[12px]" />
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="-translate-x-1/2 absolute font-['Inter:Medium',sans-serif] font-medium leading-[24px] left-[59.64px] not-italic text-[#6e7891] text-[16px] text-center top-[14.46px] whitespace-nowrap">Cancel</p>
      </div>
    </div>
  );
}

function Container49() {
  return (
    <div className="absolute content-stretch flex gap-[11.997px] h-[54.302px] items-start left-[106.6px] top-[1617.85px] w-[1199.997px]" data-name="Container">
      <Button7 />
      <Button8 />
    </div>
  );
}

export default function ManageTeamPage() {
  return (
    <div className="bg-[#f9fafb] relative size-full" data-name="ManageTeamPage">
      <Header />
      <InfoCard />
      <TeamSizeRules />
      <CurrentTeamSize />
      <Button />
      <Container18 />
      <Container25 />
      <Container49 />
    </div>
  );
}